import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const useWordCloudFiltersForProject = (projectId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['wordCloudFilters', projectId],
        queryFn: () => getWordCloudFilters(projectId)
    });

    return { data, refetch, isLoading, isError };
};

const getWordCloudFilters = async (projectId) => {
    const { data } = await vlqrApi.get(`TextAnalysis/WordCloudFilters/${projectId}/`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

export default useWordCloudFiltersForProject;